<template>
  <el-radio-group
    v-if="isDesktop"
    v-model="value"
    class="desktop"
    :disabled="disabled"
    @update:modelValue="update"
  >
    <el-radio-button v-for="item in tabItems" :key="item.id" :value="item.id">
      {{ item.label }}
    </el-radio-button>
  </el-radio-group>
  <el-select
    v-else
    v-model="value"
    :disabled="disabled"
    @update:modelValue="update"
  >
    <el-option
      v-for="item in tabItems"
      :key="item.id"
      :label="item.label"
      :value="item.id"
    >
      {{ item.label }}
    </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'WidgetPeridodSelector',
  props: {
    modelValue: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const update = (newValue: any) => {
      context.emit('update:modelValue', Number(newValue))
    }
    const tabItems = [
      {
        label: 'Today',
        id: 1
      },
      {
        label: 'Yesterday',
        id: 2
      },
      {
        label: 'Last 7 days',
        id: 3
      },
      {
        label: 'Last 30 days',
        id: 4
      },
      {
        label: 'This month',
        id: 5
      },
      {
        label: 'Last month',
        id: 6
      }
    ]
    const { isDesktop } = useResize()

    return { update, isDesktop, tabItems, value }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
:deep(.el-radio-button__inner) {
  padding: 12px 8px;
}
</style>
